import { render, staticRenderFns } from "./UserBind.vue?vue&type=template&id=60f25e8a&v-if=showUserBind&"
import script from "./UserBind.vue?vue&type=script&lang=js&"
export * from "./UserBind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports